import { StageStatusEnum } from 'api/adminApiClient';
import { StepValidationStatuses } from 'enums';
import { BulkImportStagesModel } from 'components/wrappers/BaseBulkImportStep';

const getStageNumber = (stageIndex: number) => {
  const stageNumber = stageIndex + 1;

  return `${stageIndex < 9 ? '0' : ''}${stageNumber}.`;
};

export const PENDING_STEP_ICON = 'icon-check';
export const SUCCESS_STEP_ICON = 'icon-check';
export const HALF_COMPLETED_STEP_ICON = 'icon-attention';
export const ERROR_STEP_ICON = 'icon-close-sm';
export const WARNING_STEP_ICON = 'icon-attention';

const getStepIcon = (stageType: StageStatusEnum) => {
  switch (stageType) {
    case StageStatusEnum.SoftStop:
      return WARNING_STEP_ICON;

    case StageStatusEnum.SoftStopHalfCompleted:
      return HALF_COMPLETED_STEP_ICON;

    case StageStatusEnum.HardStop:
      return ERROR_STEP_ICON;

    case StageStatusEnum.Pending:
    default:
      return PENDING_STEP_ICON;
  }
};

const getImportStepIcon = (stageType: StepValidationStatuses) => {
  switch (stageType) {
    case StepValidationStatuses.Finish:
      return SUCCESS_STEP_ICON;

    case StepValidationStatuses.Error:
      return ERROR_STEP_ICON;

    case StepValidationStatuses.Process:
    default:
      return PENDING_STEP_ICON;
  }
};

const calculatePercent = (stages: BulkImportStagesModel[]) => {
  const countOfFinished = stages.filter(
    (stage) => stage.status === StepValidationStatuses.Finish,
  ).length;

  return +((100 * countOfFinished) / stages.length).toFixed(2);
};

export { getStageNumber, getStepIcon, getImportStepIcon, calculatePercent };
